import api from "./api";

export const getSurveys = async () => {
  const { data } = await api.get("/surveys");
  return data;
};

export const createSurvey = async (survey) => {
  const payload = {
    name: survey.name,
    description: survey.description,
    status: survey.status,
    questions: survey.questions || [],
    project_ids: survey.project_ids || [],
  };
  const { data } = await api.post("/surveys", payload);
  return data;
};

export const updateSurvey = async (id, survey) => {
  const payload = {
    name: survey.name,
    description: survey.description,
    status: survey.status,
    questions: survey.questions || [],
    project_ids: survey.project_ids || [],
  };
  const { data } = await api.put(`/surveys/${id}`, payload);
  return data;
};

export const deleteSurvey = async (id) => {
  const { data } = await api.delete(`/surveys/${id}`);
  return data;
};

export const getSurveyAccess = async (surveyId) => {
  const { data } = await api.get(`/surveys/${surveyId}/access`);
  return data.project_ids || [];
};

export const setSurveyAccess = async (surveyId, projectIds) => {
  const { data } = await api.put(`/surveys/${surveyId}/access`, {
    project_ids: projectIds,
  });
  return data.project_ids || [];
};

export const getRampProjects = async () => {
  const { data } = await api.get("/ramp/projects");
  return data.project_ids || [];
};

export const getMyAvailableSurveys = async () => {
  const { data } = await api.get("/my-surveys/available");
  return data;
};

export const getMySubmittedSurveys = async () => {
  const { data } = await api.get("/my-surveys/submitted");
  return data;
};

export const submitSurveyResponse = async (surveyId, answers) => {
  const { data } = await api.post(`/surveys/${surveyId}/responses`, {
    answers,
  });
  return data;
};


